// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__fr1xs","prev":"styles_prev__3U+zI","next":"styles_next__FyTmG","active":"styles_active__58CG1"};